<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">policy</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Compliance</h1>
    <span *ngIf="dataSource"
      style="display: inline-flex; align-items: center; justify-content: center; padding: 2px 10px; background: #dcfce7; color: #166534; border-radius: 9999px; font-size: 0.75rem; font-weight: 700;">
      {{ dataSource.filteredData.length }} registros
    </span>
  </div>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Valor de busqueda</mat-label>
          <mat-icon matPrefix style="color: #9ca3af;">search</mat-icon>
          <input matInput type="text" (keyup)="doFilter($event)" placeholder="Buscar por email, nombre, ID...">
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field">
          <mat-label>Estado compliance</mat-label>
          <mat-icon matPrefix style="color: #9ca3af;">filter_alt</mat-icon>
          <mat-select (selectionChange)="doFilter($event.value)" placeholder="Filtrar por estado">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let option of filterOptions" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Card Tabla -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">list_alt</mat-icon>
        Listado Compliance
      </h2>
    </div>

    <!-- Paginator -->
    <div class="p-4">
      <mat-paginator
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        showFirstLastButtons
        [pageSize]="defaultPageSize">
      </mat-paginator>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" *ngIf="dataSource" class="w-full">

        <!-- usuarioId -->
        <ng-container matColumnDef="usuarioId">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">ID</th>
          <td mat-cell *matCellDef="let row">
            <span class="inline-block text-xs font-mono font-semibold px-2 py-0.5 rounded-full"
              style="background: #f3f4f6; color: #374151;">
              {{ row.id }}
            </span>
          </td>
        </ng-container>

        <!-- email -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef style="min-width: 250px;">Email</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.email }}</span></td>
        </ng-container>

        <!-- tipoId -->
        <ng-container matColumnDef="tipoId">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Tipo Id</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.tipoUsuario === 'PERSONA' ? row.tipoId : 'Rut Empresa' }}</span></td>
        </ng-container>

        <!-- numeroId -->
        <ng-container matColumnDef="numeroId">
          <th mat-header-cell *matHeaderCellDef style="min-width: 150px;">Documento</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.tipoUsuario === 'PERSONA' ? row.numeroId : row.rutEmpresa }}</span></td>
        </ng-container>

        <!-- tipoUsuario -->
        <ng-container matColumnDef="tipoUsuario">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Tipo</th>
          <td mat-cell *matCellDef="let row">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="row.tipoUsuario === 'PERSONA' ? '#dbeafe' : '#fef3c7'"
              [style.color]="row.tipoUsuario === 'PERSONA' ? '#1e40af' : '#92400e'">
              {{ row.tipoUsuario }}
            </span>
          </td>
        </ng-container>

        <!-- nombre -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef style="min-width: 150px;">Nombre</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.tipoUsuario === 'PERSONA' ? row.nombre : row.razonSocial }}</span></td>
        </ng-container>

        <!-- apellidos -->
        <ng-container matColumnDef="apellidos">
          <th mat-header-cell *matHeaderCellDef style="min-width: 150px;">Apellidos</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.tipoUsuario === 'PERSONA' ? row.apellidos : '' }}</span></td>
        </ng-container>

        <!-- paisResidencia -->
        <ng-container matColumnDef="paisResidencia">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Pais</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.paisResidencia }}</span></td>
        </ng-container>

        <!-- total_transferido -->
        <ng-container matColumnDef="total_transferido">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Total transferido</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs font-mono">0</span></td>
        </ng-container>

        <!-- limite_alcanzado -->
        <ng-container matColumnDef="limite_alcanzado">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Limite alcanzado</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">NO</span></td>
        </ng-container>

        <!-- esPoliticamenteExpuesto -->
        <ng-container matColumnDef="esPoliticamenteExpuesto">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">PEP</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.esPoliticamenteExpuesto }}</span></td>
        </ng-container>

        <!-- esRTP -->
        <ng-container matColumnDef="esRTP">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">RTP</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.esRTP }}</span></td>
        </ng-container>

        <!-- esListaONU -->
        <ng-container matColumnDef="esListaONU">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">Lista ONU</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ row.esListaONU }}</span></td>
        </ng-container>

        <!-- KYC1 -->
        <ng-container matColumnDef="KYC1">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">KYC 1</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs"></span></td>
        </ng-container>

        <!-- KYC2 -->
        <ng-container matColumnDef="KYC2">
          <th mat-header-cell *matHeaderCellDef style="min-width: 60px;">KYC 2</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs"></span></td>
        </ng-container>

        <!-- estado_compliance -->
        <ng-container matColumnDef="estado_compliance">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Estado compliance</th>
          <td mat-cell *matCellDef="let row">
            <mat-icon
              [style.color]="getComplianceColor(row)"
              [matTooltip]="row.estadoCompliance"
              style="font-size: 20px; width: 20px; height: 20px;">
              {{ getComplianceIcon(row) }}
            </mat-icon>
          </td>
        </ng-container>

        <!-- fecha_creacion -->
        <ng-container matColumnDef="fecha_creacion">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Fecha de creacion</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ getDateCreacion(row) }}</span></td>
        </ng-container>

        <!-- fecha_actualizacion -->
        <ng-container matColumnDef="fecha_actualizacion">
          <th mat-header-cell *matHeaderCellDef style="min-width: 140px;">Ultima actualizacion</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ getDateActualizacion(row) }}</span></td>
        </ng-container>

        <!-- responsable -->
        <ng-container matColumnDef="responsable">
          <th mat-header-cell *matHeaderCellDef style="min-width: 250px;">Responsable</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs">{{ getResponsable(row) }}</span></td>
        </ng-container>

        <!-- motivo_bloqueo -->
        <ng-container matColumnDef="motivo_bloqueo">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Motivo bloqueo</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs"></span></td>
        </ng-container>

        <!-- dias_bloqueo -->
        <ng-container matColumnDef="dias_bloqueo">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Dias bloqueo</th>
          <td mat-cell *matCellDef="let row"><span class="text-xs"></span></td>
        </ng-container>

        <!-- acciones -->
        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef style="width: 80px; text-align: center;">Acciones</th>
          <td mat-cell *matCellDef="let row" style="width: 80px; text-align: center;">
            <button title="Ver detalle" [routerLink]="['/retail/compliance', row.email]"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell text-center text-gray-400 py-8" [attr.colspan]="displayedColumns.length">
            No se encontraron registros
          </td>
        </tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden space-y-3 p-4" *ngIf="dataSource">
      <div *ngFor="let row of dataSource.filteredData; let i = index"
        class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
        [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'">

        <!-- Card Header -->
        <div class="flex items-center justify-between p-3 cursor-pointer"
          (click)="toggleCard(i)"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div class="flex items-center gap-2 flex-1 min-w-0">
            <span class="inline-block text-xs font-mono font-semibold px-2 py-0.5 rounded-full shrink-0"
              style="background: #f3f4f6; color: #374151;">
              #{{ row.id }}
            </span>
            <span class="text-xs font-semibold text-gray-700 truncate">{{ row.email }}</span>
          </div>
          <div class="flex items-center gap-2 shrink-0">
            <span class="inline-block text-xs font-semibold px-2 py-0.5 rounded-full"
              [style.background]="row.estadoCompliance === 'APROBADO' ? '#16a34a' :
                                  row.estadoCompliance === 'POR APROBAR' ? '#eab308' :
                                  row.estadoCompliance === 'RECHAZADO' ? '#dc2626' :
                                  row.estadoCompliance === 'BLACK LIST' ? '#991b1b' : '#6b7280'"
              style="color: white;">
              {{ row.estadoCompliance }}
            </span>
            <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
              [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
              expand_more
            </mat-icon>
          </div>
        </div>

        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
          <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Usuario</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.tipoUsuario }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Tipo Id</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.tipoUsuario === 'PERSONA' ? row.tipoId : 'Rut Empresa' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Documento</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.tipoUsuario === 'PERSONA' ? row.numeroId : row.rutEmpresa }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Nombre</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.tipoUsuario === 'PERSONA' ? row.nombre : row.razonSocial }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Apellidos</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.tipoUsuario === 'PERSONA' ? row.apellidos : '' }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Pais</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.paisResidencia }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">PEP</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.esPoliticamenteExpuesto }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">RTP</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.esRTP }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Lista ONU</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ row.esListaONU }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Fecha creacion</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ getDateCreacion(row) }}</p>
            </div>
            <div>
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Ultima actualizacion</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ getDateActualizacion(row) }}</p>
            </div>
            <div class="col-span-2">
              <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Responsable</span>
              <p class="text-gray-700 font-medium mt-0.5">{{ getResponsable(row) }}</p>
            </div>
          </div>

          <!-- Card Footer -->
          <div class="flex gap-2 mt-3 pt-3 border-t border-gray-100">
            <button [routerLink]="['/retail/compliance', row.email]"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #166534;"
              onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #166534;">visibility</mat-icon>
              Ver detalle
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="dataSource.filteredData.length === 0" class="text-center text-gray-400 py-8">
        No se encontraron registros
      </div>
    </div>
  </div>
</div>
